import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { MenuItem, ListItemText, Button, Popover, Box, ListItemButton } from '@mui/material';
import _ from 'lodash';
import { SelectBoxButton } from 'theme/elements/Buttons';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import { useAppSelector } from 'hooks/redux.hooks';
import { getDir } from 'state/reducers/translation.reducers';

export type SelectedList = { name: string; value: string }[];

type selectorProps = {
	options: SelectedList;
	primaryOption?: string;
	label?: string;
	handleChange?: (list: SelectedList) => void;
};

export default function MultipleSelectCheckmarks(props: selectorProps) {
	const dir = useAppSelector(getDir);
	const [selected, setSelected] = React.useState<{ name: string; value: string }[]>([]);
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const checked = event.target.checked;
		const name = event.target.name;
		const option = { name: name, value: event.target.value };
		let selecting: SelectedList = [];

		if (name === 'all') {
			selecting = !checked ? [] : props.options;
		} else {
			selecting = checked ? [...selected, option] : _.filter(selected, (option) => option.name !== name);
		}
		setSelected(selecting);
		if (props.handleChange) {
			let final = props.options.length === selecting.length ? [] : selecting;
			props.handleChange(final);
		}
	};

	const isAllSelected = props.options.length > 0 && selected.length === props.options.length;

	return (
		<Box>
			<SelectBoxButton>
				<Button
					className={selected.length > 0 && !isAllSelected ? 'selectedItems' : ''}
					aria-describedby={id}
					variant="contained"
					onClick={handleClick}
					endIcon={<ArrowDropDown />}
				>
					{selected.length === 0 || isAllSelected ? '' : selected.length}
					{' ' + props?.label}
				</Button>
			</SelectBoxButton>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
			>
				<Box dir={dir}>
				<ListItemButton component="label" >
					<Checkbox
						name="all"
						onChange={handleChange}
						checked={isAllSelected}
						indeterminate={selected.length > 0 && selected.length < props.options.length}
					/>
					<ListItemText
						primary={props.primaryOption}
					/>
				</ListItemButton>
				{props.options.map((option) => (
					<ListItemButton key={option.name} component="label" >
						<Checkbox
							name={option.name}
							value={option.value}
							onChange={handleChange}
							checked={!_.isEmpty(_.find(selected, option))}
						/>
						<ListItemText
							primary={option.name}
						/>
					</ListItemButton>
				))}
				</Box>
			</Popover>
		</Box>
	);
}
